import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";
import PersonalInformation from "./user-details-tabs/PersonalInformation";
// import MembershipDetails from "./user-details-tabs/MembershipDetails.jsx";
// import FitnessStats from "./user-details-tabs/FitnessStats";
// import Activity from "./user-details-tabs/Activity";
// import CalenderSchedules from "./user-details-tabs/CalenderSchedules";
// import CoinsHistory from "./user-details-tabs/CoinsHistory";
import { getDataApi } from "../../../data/axios.js";
import moment from "moment";
import { selectToken } from "../../auth/auth.selector.js";
import MembershipDetails from "../../pt/pt-flow-new/users-info/MembershipDetails.jsx";

const UserDetailsTabs = ({
  ftProfileData,
  row,
  currentMembership,
  setCurrentMemberShip,
  userInfoData,
}) => {
  const token = useSelector(selectToken);
  // const [isLoadingMem, setIsLoadingMem] = useState(false);
  const [userData, setUserData] = useState(null);
  const [dietData, setDietData] = useState();
  const [dietToday, setDietToday] = useState();

  const dietCatId = userData?.diet_category_id || row?.diet_category_id;
  const userId = userData?.user_id || row?.user_id;

  async function getDietData() {
    try {
      const { data, status, diet_today } = await getDataApi({
        url: `dietcat/diet?uid=${dietCatId}&user_id=${userId}&day=${getDay()}&date=${moment()
          .tz("Asia/Kolkata")
          .format("DD-MM-YYYY")}`,
        token,
      });

      if (status) {
        setDietData(data);
        setDietToday(diet_today);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getDay = () => {
    try {
      const day = moment().tz("Asia/Kolkata").day();
      const days = {
        0: "sunday",
        1: "monday",
        2: "tuesday",
        3: "wednesday",
        4: "thursday",
        5: "friday",
        6: "saturday",
      };
      return days[day];
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    try {
      if (dietCatId && userId) {
        getDietData();
      }
    } catch (error) {
      console.log(error);
    }
  }, [dietCatId, userId]);

  return (
    <div className="mb-2-k w-full-k">
      <Tabs
        id="uncontrolled-user-details-tab"
        className="userDetailsTabsContainer flex-col-mobile js-start-k gap-1-k"
      >
        <Tab eventKey="membership" title="Membership">
          <MembershipDetails userInfoData={userInfoData} rowData={row} />

          {/* <MembershipDetails
            currentMembership={currentMembership}
            setCurrentMemberShip={setCurrentMemberShip}
            setIsLoading={setIsLoadingMem}
            isLoading={isLoadingMem}
            row={row}
          /> */}
        </Tab>

        <Tab eventKey="personal-information" title="Personal Information">
          <PersonalInformation
            userInfoData={userInfoData}
            userData={userData}
            setUserData={setUserData}
            row={row}
            ftProfileData={ftProfileData}
          />
        </Tab>

        {/* <Tab eventKey="fitness-stats" title="Fitness stats">
          <FitnessStats
            // currentMembership={currentMembership}
            currentMembership={row}
            userStats={ftProfileData}
            dietData={dietData}
            dietToday={dietToday}
            isLoadingLast={isLoadingMem}
          />
        </Tab> */}

        {/* <Tab eventKey="checkins" title="Checkins">
          <CalenderSchedules />
        </Tab> */}

        {/* <Tab eventKey="coins-history" title="Coins History">
          <CoinsHistory row={row} />
        </Tab> */}

        {/* <Tab eventKey="activity" title="Activity">
          <Activity />
        </Tab> */}
      </Tabs>
    </div>
  );
};

export default UserDetailsTabs;
